import type { DocumentEmailHistoryType } from '@econtractor/types';
import { useTranslation } from 'react-i18next';
import { UserNameItem } from 'modules/user';
import DateTimeDisplay from 'components/dateTime/DateTimeDisplay';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import EOverlay from 'components/others/EOverlay';
import { escapeHtml } from 'utils/helpers/functions/escapeHtml';

interface EmailHistoryTableRowProps {
    row: DocumentEmailHistoryType;
}

const EmailHistoryTableRow = ({ row }: EmailHistoryTableRowProps) => {
    const { t } = useTranslation('Proposal');
    const emails = row.recipients.split(',').map((email) => email.trim()).filter(Boolean);
    const emailBody = String(row.emailBody || '').trim();

    return (
        <tr>
            <td className="username">
                <UserNameItem
                    smallMode
                    user={{
                        ID: row.userId,
                        userName: row.userName || `#${row.userId}`,
                        userEmail: row.userEmail,
                        userPicture: row.userPicture,
                    }}
                />
            </td>
            <td className="date"><DateTimeDisplay value={Number(row.sentAt)} /></td>
            <td className="email">
                <div className="d-flex flex-column align-items-start gap-1">
                    {emails.map((email, index) => (
                        <CopyTextWrapper key={`${email}-${index}`} value={email}>
                            <a href={`mailto:${email}`} className="d-block text-truncate" title={email}>{email}</a>
                        </CopyTextWrapper>
                    ))}
                </div>
            </td>
            <td className="comment text-center">
                <span className="proposal-comment-icon-wrap" title={t('edit.generate.logEmailBodyHint')}>
                    <EOverlay text={emailBody ? `<div>${escapeHtml(emailBody)}</div>` : ''} iconClass="bi-envelope" />
                </span>
            </td>
        </tr>
    );
};

export default EmailHistoryTableRow;
